import { Theme } from '@mui/material/styles';

export const getMuiAccordionSummary = (
  theme: Theme,
): Record<string, unknown> => ({
  MuiAccordionSummary: {
    styleOverrides: {
      root: {
        padding: theme.spacing(0, 2),

        '&.Mui-expanded': {
          minHeight: 'unset',
        },

        [theme.breakpoints.up('md')]: {
          padding: 0,
        },
      },

      content: {
        alignItems: 'flex-start',
        display: 'flex',
        flexFlow: 'row nowrap',
        justifyContent: 'flex-start',
        margin: 0,
        padding: 0,
        paddingRight: theme.spacing(1),

        '&.Mui-expanded': {
          margin: theme.spacing(0, 0, 2.5),
        },
        '& [class*="MuiTypography-body2"]': {
          color: theme.palette.grey[600],
        },
        [theme.breakpoints.up('sm')]: {
          margin: 0,

          '&.Mui-expanded': {
            margin: theme.spacing(0, 0, 2.5),
          },
          '& [class*="MuiTypography-body2"]': {
            color: theme.palette.grey[600],
          },
        },
      },

      expandIconWrapper: {
        backgroundColor: theme.palette.grey[200],
        borderRadius: '50%',
        margin: 0,
        padding: theme.spacing(0.75),

        '&.Mui-expanded': {
          margin: theme.spacing(0, 0, 2.5),
        },
        '&[class*="MuiIconButton-edgeEnd"]': {
          marginRight: 0,
        },
        '&:hover': {
          backgroundColor: 'none',
        },
        [theme.breakpoints.down('sm')]: {
          backgroundColor: 'unset',
        },
      },
    },
  },
});
